interface InactivityWarningBannerProps {
  show: boolean;
  secondsRemaining: number;
  onDismiss: () => void;
}

export default function InactivityWarningBanner({
  show,
  secondsRemaining,
  onDismiss,
}: InactivityWarningBannerProps) {
  if (!show) return null;

  const progressPercent = (secondsRemaining / 60) * 100;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9998] animate-slideDown">
      <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-xl shadow-2xl overflow-hidden max-w-md w-full mx-4">
        {/* Progress bar */}
        <div className="h-1 bg-white/20">
          <div
            className="h-full bg-white transition-all duration-1000 ease-linear"
            style={{ width: `${progressPercent}%` }}
          ></div>
        </div>

        {/* Content */}
        <div className="px-5 py-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 animate-pulse">
              <i className="ri-alarm-warning-line text-2xl text-white"></i>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-bold text-white mb-1">
                Session inactive — Verrouillage imminent
              </h3>
              <p className="text-xs text-white/90 leading-relaxed">
                Votre session sera verrouillée dans{' '}
                <span className="font-bold text-base">{secondsRemaining}s</span> en raison d'inactivité.
                Bougez votre souris ou appuyez sur une touche pour rester connecté.
              </p>
            </div>
            <button
              onClick={onDismiss}
              className="flex-shrink-0 w-6 h-6 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer"
              aria-label="Fermer"
            >
              <i className="ri-close-line text-white text-lg"></i>
            </button>
          </div>

          {/* Action hint */}
          <div className="mt-3 flex items-center gap-2 text-xs text-white/80">
            <i className="ri-mouse-line"></i>
            <span>Déplacez votre souris pour réinitialiser le minuteur</span>
          </div>
        </div>
      </div>
    </div>
  );
}